// Tree-shaken ECharts entry. Importing from "echarts" pulls the entire library
// (~1MB); register-only what we actually render.

import * as echarts from "echarts/core";
import {
  CandlestickChart,
  LineChart,
  BarChart,
  TreemapChart,
} from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  DataZoomComponent,
  MarkLineComponent,
  LegendComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  CandlestickChart,
  LineChart,
  BarChart,
  TreemapChart,
  GridComponent,
  TooltipComponent,
  DataZoomComponent,
  MarkLineComponent,
  LegendComponent,
  CanvasRenderer,
]);

export { echarts };

// Slate palette — keep in lockstep with tailwind config and the existing UI.
export const PALETTE = {
  bg: "#0f172a",
  text: "#cbd5e1",
  muted: "#64748b",
  grid: "#1e293b",
  up: "#34d399",
  down: "#f87171",
  accent: "#38bdf8",
  bull: "#34d399",
  bear: "#f87171",
};

export const baseTextStyle = { color: PALETTE.text, fontSize: 11 };

export const baseAxis = {
  axisLine: { lineStyle: { color: PALETTE.grid } },
  axisTick: { lineStyle: { color: PALETTE.grid } },
  splitLine: { lineStyle: { color: PALETTE.grid } },
  axisLabel: { color: PALETTE.muted, fontSize: 10 },
};

export const baseTooltip = {
  trigger: "axis" as const,
  backgroundColor: "rgba(15,23,42,0.95)",
  borderColor: PALETTE.grid,
  textStyle: { color: PALETTE.text, fontSize: 11 },
};
